import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DetailsSheetViewModel } from '../../components/DetailsSheet/logic/types';

interface UIState {
  detailsDrawer: {
    isOpen: boolean;
    translationRecordId: string | null;
    viewModel: DetailsSheetViewModel | null;
  };
  deactivationDialog: {
    isOpen: boolean;
  };
}

const initialState: UIState = {
  detailsDrawer: {
    isOpen: false,
    translationRecordId: null,
    viewModel: null,
  },
  deactivationDialog: {
    isOpen: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openTranslationDetails: (state, action: PayloadAction<string>) => {
      state.detailsDrawer.isOpen = true;
      state.detailsDrawer.translationRecordId = action.payload;
      state.detailsDrawer.viewModel = null; // Reset view model when opening new translation
    },
    closeTranslationDetails: (state) => {
      state.detailsDrawer.isOpen = false;
      state.detailsDrawer.translationRecordId = null;
      state.detailsDrawer.viewModel = null;
    },
    setDetailsViewModel: (state, action: PayloadAction<DetailsSheetViewModel | null>) => {
      state.detailsDrawer.viewModel = action.payload as any;
    },
    openDeactivationDialog: (state) => {
      state.deactivationDialog.isOpen = true;
    },
    closeDeactivationDialog: (state) => {
      state.deactivationDialog.isOpen = false;
    },
  },
});

export const { openTranslationDetails, closeTranslationDetails, setDetailsViewModel, openDeactivationDialog, closeDeactivationDialog } = uiSlice.actions;
export default uiSlice.reducer;
